"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var color_1 = __importDefault(require("color"));
var colors_1 = __importDefault(require("../../../assets/jss/colors"));
var typography_1 = require("../../../shared/theme/typography");
var styles = function (theme, customerVariant) {
    var _a, _b;
    return (0, styles_1.makeStyles)({
        ticketCardContent: {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            textAlign: 'center',
            flex: 1,
            flexGrow: 1,
            maxWidth: '480px',
            width: '100%',
            padding: '44px',
            margin: 0,
            backgroundColor: theme.palette.background.default
        },
        labelCenter: {
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center'
        },
        ticketTitle: (_a = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: customerVariant === 'ks' ? '24px' : '36px'
            },
            _a[theme.breakpoints.up('lg')] = {
                textAlign: 'center'
            },
            _a),
        helpInformationBox: (_b = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                gap: customerVariant === 'ks' ? '24px' : '36px'
            },
            _b[theme.breakpoints.up('lg')] = {
                textAlign: 'center'
            },
            _b),
        cardLabelStyle: {
            display: 'flex',
            paddingTop: theme.spacing(2),
            justifyContent: 'center',
            fontSize: customerVariant === 'ks' ? '18px' : '20px',
            fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SatoshiBold : typography_1.themeFonts.MontserratBold
        },
        inputListSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        },
        spacing: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        tooltipButton: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            textAlign: 'center',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '100%'
        },
        tooltipText: {
            textDecoration: customerVariant === 'ks' ? 'underline' : 'none',
            textUnderlineOffset: '4px',
            textTransform: 'none',
            textAlign: 'center',
            fontFamily: customerVariant === 'ks' ? typography_1.themeFonts.SatoshiBold : typography_1.themeFonts.MontserratMedium,
            letterSpacing: customerVariant === 'ks' ? undefined : '1.3px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            maxWidth: '100%'
        },
        flexDirectionColumn: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        inputAdornment: {
            '& p': {
                color: 'rgba(12, 19, 26, 0.7)'
            }
        },
        input: {
            textAlign: 'center',
            '&::placeholder': {
                textAlign: 'center',
                color: customerVariant === 'ks' ? colors_1.default.textSecondaryColor.hex() : theme.palette.common.black,
                opacity: customerVariant === 'ks' ? undefined : 0.6
            }
        },
        ticketLink: {
            padding: '0 35px',
            textAlign: 'center',
            textDecoration: customerVariant === 'ks' ? 'underline' : 'none',
            textUnderlineOffset: '4px'
        },
        button: {
            marginTop: '36px',
            marginBottom: theme.spacing(3),
            height: '48px',
            width: '160px',
            alignSelf: 'center'
        },
        dialogBackdrop: {
            backgroundColor: (0, color_1.default)(theme.palette.grey[500])
                .alpha(0.8)
                .rgb()
                .string()
        },
        dialog: {
            backgroundColor: theme.palette.background.default,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            width: '600px'
        },
        dialogContent: {
            padding: 0
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map